import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useState } from "react";
import { openModal } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../api/firebase/firestoreService";

export interface UseAsteraScreenshotReturn {
  asteraScreenshotDownloadUrl: string | null;
  asteraScreenshotModalOpen: boolean;
  selectedRowData: any | null;
  handleViewClick: (rowData: any) => Promise<void>;
  closeAsteraScreenshotModal: () => void;
  externalLoading: boolean;
}

export const useAsteraScreenshot = (): UseAsteraScreenshotReturn => {
  const [asteraScreenshotDownloadUrl, setAsteraScreenshotDownloadUrl] =
    useState<string | null>(null);
  const [asteraScreenshotModalOpen, setAsteraScreenshotModalOpen] =
    useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
  const [externalLoading, setExternalLoading] = useState<boolean>(false);

  useEffect(() => {
    if (asteraScreenshotModalOpen) {
      openModal("doc-viewer-modal");
    }
  }, [asteraScreenshotModalOpen]);

  const handleViewClick = async (rowData: any) => {
    setSelectedRowData(rowData);
    setAsteraScreenshotDownloadUrl(null);

    // Open modal immediately
    setAsteraScreenshotModalOpen(true);
    setExternalLoading(true);

    // Fetch data asynchronously
    try {
      const uniqueId = rowData.identifier;
      if (!uniqueId) {
        setAsteraScreenshotDownloadUrl(null);
        setExternalLoading(false);
        toast.error("No identifier found");
        return;
      }

      const filePath = `astera/${uniqueId}/attachment.png`;

      const downloadUrl = await getFileDownloadUrl(filePath);
      setAsteraScreenshotDownloadUrl(downloadUrl);
    } catch (error) {
      console.error("Error fetching Astera screenshot:", error);
      setAsteraScreenshotDownloadUrl(null);
    } finally {
      setExternalLoading(false);
    }
  };

  const closeAsteraScreenshotModal = () => {
    setAsteraScreenshotModalOpen(false);
  };

  return {
    asteraScreenshotDownloadUrl,
    asteraScreenshotModalOpen,
    selectedRowData,
    handleViewClick,
    closeAsteraScreenshotModal,
    externalLoading,
  };
};
